import axios from 'axios';
import { CompanyPositionBody } from '../schemas/esignatureLog.schema';

export async function putCompanyPositionLog(body: CompanyPositionBody) {
    return axios.put('/v1/updatecompanyposition', body, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}
